import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  Box,
  Button,
  FormLabel,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { confirmPasswordReset, verifyPasswordResetCode } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Logo from "../../assets/imgNew/brand/logo-white.png";
import ResetPasswordImage from "../../assets/imgNew/my-password.png";
import { colors } from "../../assets/theme/base/colors";
import { auth } from "../../config/firebase";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { setIsLoading, showSnackbar } from "../../store/system.store";
import { UserService } from "../../services/user.service";
import useScreen from "../../components/common/UseScreen";
import "./resetPassword.scss";

const SetNewPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { isMobile } = useScreen();
  const [validations, setValidations] = useState({
    uppercase: false,
    lowercase: false,
    length: false,
    number: false,
    specialChar: false,
  });

  const navigate = useNavigate();
  const [params] = useSearchParams();

  const mode = params.get("mode");
  const oobCode = params.get("oobCode");
  useEffect(() => {
    if (mode !== "resetPassword") {
      navigate("/");
    }
  }, []);

  const dispatch = useDispatch();

  const validatePassword = (value: string) => {
    const uppercaseRegex = /[A-Z]/;
    const lowercaseRegex = /[a-z]/;
    const numberRegex = /[0-9]/;
    const specialCharRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
    const length = value.length >= 8 && value.length <= 20;

    setValidations({
      uppercase: uppercaseRegex.test(value),
      lowercase: lowercaseRegex.test(value),
      length,
      number: numberRegex.test(value),
      specialChar: specialCharRegex.test(value),
    });
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setPassword(newValue);
    validatePassword(newValue);
  };

  const handleConfirmPasswordChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newValue = e.target.value;
    setConfirmPassword(newValue);
  };
  const handleSubmit = async (ev: any) => {
    ev.preventDefault();
    try {
      dispatch(setIsLoading(true));
      if (oobCode) {
        const data: any = await UserService.setInitialPassword(oobCode);
        if (data.code === 201) {
          showSnackbar({ msg: `Password is already set.` });
          navigate("/login");
        } else if (data.code === 200) {
          verifyPasswordResetCode(auth, oobCode)
            .then(() => {
              confirmPasswordReset(auth, oobCode, password)
                .then(function () {
                  navigate("/login");
                })
                .catch(() => showSnackbar({ msg: `Something went wrong.` }));
            })
            .catch((err: any) => {
              showSnackbar({ msg: `${err}` });
            });
        }
        dispatch(setIsLoading(false));
      }
    } catch (error) {
      console.log("Error in SetNewPassword: ", error);
      dispatch(setIsLoading(false));
      showSnackbar({ msg: "Something went wrong." });
    }
  };

  useEffect(() => {
    dispatch(setIsLoading(false));
  }, []);

  return (
    <div className="set-password-page">
      <Box className="wrapper">
        {!isMobile ? (
          <Box className="wrapper-left">
            <Box className="content">
              <img src={ResetPasswordImage} />
            </Box>
          </Box>
        ) : null}
        <Box className={!isMobile ? "wrapper-right" : "wrapper-mobile"}>
          <Box className="login-container">
            <Stack className={"form-container"}>
              <Box className={"form-heading"}>
                <Box className="logo-wrapper">
                  <img src={Logo} width={"56px"} height={"56px"} />
                </Box>
                <Typography
                  variant="h1"
                  sx={{
                    margin: "0px 0px 8px",
                    fontSize: "1.5rem",
                    fontWeight: 700,
                  }}
                >
                  Set New Password
                </Typography>
                <Typography className="p">
                  Set a new password to maximize user protection
                </Typography>
              </Box>

              <Box
                className="form"
                width={"100%"}
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <Box className="form-control password">
                  <FormLabel
                    sx={{
                      width: "100%",
                      fontSize: "0.875rem !important",
                      fontWeight: 600,
                      display: "block",
                      color: "var(--black)",
                    }}
                    htmlFor="email"
                  >
                    New Password
                  </FormLabel>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={handlePasswordChange}
                    style={{
                      width: "100% !important",
                      background: "none !important",
                      height: "44px",
                      margin: "0px",
                      display: "block",
                      padding: "12px 14px",
                      borderRadius: "7px",
                      border: "1px solid var(--gray)",
                      outline: 0,
                    }}
                  />
                  <IconButton
                    className="hide-show-button"
                    onClick={() => {
                      setShowPassword(!showPassword);
                    }}
                  >
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </Box>
                <Box className="form-control password">
                  <FormLabel
                    sx={{
                      width: "100%",
                      fontSize: "0.875rem !important",
                      fontWeight: 600,
                      display: "block",
                      color: "var(--black)",
                    }}
                    htmlFor="email"
                  >
                    Confirm New Password
                  </FormLabel>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    style={{
                      width: "100% !important",
                      background: "none !important",
                      height: "44px",
                      margin: "0px",
                      display: "block",
                      padding: "12px 14px",
                      borderRadius: "7px",
                      border: "1px solid var(--gray)",
                      outline: 0,
                    }}
                  />
                  <IconButton
                    className="hide-show-button"
                    onClick={() => {
                      setShowConfirmPassword(!showConfirmPassword);
                    }}
                  >
                    {showConfirmPassword ? (
                      <VisibilityOffIcon />
                    ) : (
                      <VisibilityIcon />
                    )}
                  </IconButton>
                </Box>

                <Box className="form-control" sx={{ padding: "0" }}>
                  <ul
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(2, 1fr)",
                      padding: "0",
                    }}
                  >
                    <li
                      className="validates-line"
                      style={{
                        color: validations.uppercase
                          ? "black"
                          : colors.colorGreyMuted,
                      }}
                    >
                      {validations.uppercase ? (
                        <CheckIcon sx={{ color: "green" }} />
                      ) : (
                        <CloseIcon sx={{ color: colors.mainTextBlue }} />
                      )}
                      At least 1 uppercase letter
                    </li>
                    <li
                      className="validates-line"
                      style={{
                        color: validations.lowercase
                          ? "black"
                          : colors.colorGreyMuted,
                      }}
                    >
                      {validations.lowercase ? (
                        <CheckIcon sx={{ color: "green" }} />
                      ) : (
                        <CloseIcon sx={{ color: colors.mainTextBlue }} />
                      )}
                      At least 1 lowercase letter
                    </li>
                    <li
                      className="validates-line"
                      style={{
                        color: validations.length
                          ? "black"
                          : colors.colorGreyMuted,
                      }}
                    >
                      {validations.length ? (
                        <CheckIcon sx={{ color: "green" }} />
                      ) : (
                        <CloseIcon sx={{ color: colors.mainTextBlue }} />
                      )}
                      Between 8 to 20 characters
                    </li>
                    <li
                      className="validates-line"
                      style={{
                        color: validations.number
                          ? "black"
                          : colors.colorGreyMuted,
                      }}
                    >
                      {validations.number ? (
                        <CheckIcon sx={{ color: "green" }} />
                      ) : (
                        <CloseIcon sx={{ color: colors.mainTextBlue }} />
                      )}
                      At least 1 number
                    </li>
                    <li
                      className="validates-line"
                      style={{
                        color: validations.specialChar
                          ? "black"
                          : colors.colorGreyMuted,
                      }}
                    >
                      {validations.specialChar ? (
                        <CheckIcon sx={{ color: "green" }} />
                      ) : (
                        <CloseIcon sx={{ color: colors.mainTextBlue }} />
                      )}
                      At least 1 special character
                    </li>
                    {password && (
                      <li className="validates-line">
                        {password == confirmPassword ? (
                          <CheckIcon sx={{ color: "green" }} />
                        ) : (
                          <CloseIcon sx={{ color: colors.mainTextBlue }} />
                        )}

                        {password !== confirmPassword ? (
                          <>Passwords do not match!</>
                        ) : (
                          <>Passwords Match</>
                        )}
                      </li>
                    )}
                  </ul>
                </Box>

                <Box className="form-control">
                  <Button onClick={handleSubmit} variant="contained">
                    {" "}
                    Set Password
                  </Button>
                </Box>
              </Box>
            </Stack>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default SetNewPassword;
